import apiInstance from "./instance";
import endpoints from "./endpoints";

export interface LiveMarketEvent {
  game_event_id: string;
  is_active: boolean;
  source: string;
  game_id: string;
  game_name: string;
  provider_event_id: string;
  event_name: string;
  category: string;
  provider_game_id: string;
  provider_name: string;
  sub_provider_name: string;
  provider_type: string;
  game_thumbnail: string;
  game_thumbnail2: string;
  desktop_sequence: number | null;
  mobile_sequence: number | null;
  is_popular: boolean;
  is_desktop_visibility: boolean;
  is_mobile_visibility: boolean;
  is_bet_lock: boolean;
}

interface LiveMarketEventsApiResponse {
  data?: LiveMarketEvent[];
  status_code?: number;
  status_message?: string;
  response_error?: boolean;
}

export const liveMarketApi = {
  async fetchBusinessGroupGameEvents(groupId: string): Promise<LiveMarketEvent[]> {
    const { data } = await apiInstance.get<LiveMarketEventsApiResponse | LiveMarketEvent[]>(
      endpoints.business.groupGameEvents(groupId)
    );

    if (Array.isArray(data)) return data;
    if (Array.isArray(data?.data)) return data.data;
    return [];
  },
};
